module.exports = __webpack_public_path__ + "img/cool-face.57ac6168.png";